<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="SKU">
            <b-form-input type="text" name="sku" v-model="item.sku" placeholder="SKU"  v-validate="'required'" :state="validateState('sku')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('sku') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-row>
            <b-col md="4">
              <b-form-fieldset label="Quantidade">
                <b-form-input type="number" step="0.01" min="0" name="quantity" v-model="item.quantity" placeholder="Quantidade"  v-validate="'required'" :state="validateState('quantity')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('quantity') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="NIV">
                <b-form-input type="number" step="0.01" min="0" name="niv" v-model="item.niv" placeholder="NIV"  v-validate="'required'" :state="validateState('niv')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('niv') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="TO">
                <b-form-input type="number" step="0.01" min="0" name="to" v-model="item.to" placeholder="TO"  v-validate="'required'" :state="validateState('to')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('to') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'products.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Produto Agregado</strong>
          </div>
          <modal-select modal="prodaggreg-modal" v-validate="'required'" name="prodaggreg_id" :readonly="false" :item-id="item.prodaggreg_id" :item-name="item.prodaggreg?item.prodaggreg.data.name:''" v-on:select-item="selectProdaggregs"  :state="validateState('prodaggreg_id')" placeholder="Prodaggreg" label="Prodaggreg" ></modal-select>

        </b-card>
      </b-col>
      <!--/.col-->

      <b-modal no-enforce-focus @shown="showProdaggregs=true" @hidden="showProdaggregs=false" size="lg" ref="prodaggregsModal" id="prodaggregsModal">
        <prodaggregs v-if="showProdaggregs" height="400" v-on:select-prodaggreg="selectProdaggregs" />
      </b-modal>
    </div>
  </form>

</div>
</template>

<script>
import Prodaggregs from '../prodaggregs/modal.vue'
export default {
  name: 'ProductsEdit',
  props: ['id'],
  components: { Prodaggregs },
  data() {
    return {
      dataLoaded: false,
      showProdaggregs: false,
      showPassword: false,
      item: {
        name: '',
        sku: '',
        quantity: 1,
        niv:0,
        to:0
      }
    }
  },
  methods: {
    selectProdaggregs(e) {
      this.item.prodaggreg_id = e.item.id
      this.$refs.prodaggregsModal.hide()
    },
    showProdaggregsModal() {
      this.$refs.prodaggregsModal.show()
    },
    hideProdaggregsModal() {
      this.$refs.prodaggregsModal.hide()
    },
    removeTeamMember(index) {
      this.item.salesteam.data.splice(index, 1)
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('products' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'products.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('products', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'products.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('products' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'products.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
